export default __webpack_public_path__ + "static/media/nft-icon.b62441c7.svg";